document.addEventListener('DOMContentLoaded', () => {
  // 既存の変数定義
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const itemsEl = document.getElementById('cart-items');
  const totalEl = document.getElementById('cart-total');
  const closeBtn = document.getElementById('cart-close');
  const addBtns = document.querySelectorAll('.add-to-cart-button');
  const cartBtn = document.querySelector('.cart-button');


  let CartAmount = 0;
  let shortage = 0;
  const CouponThreshold = 50000;
  CartAmountRecalculation();
  async function CartAmountRecalculation() {
    const cart = await (await fetch('/cart.js')).json();
    CartAmount = Number(cart.total_price/100);
    if(CartAmount < CouponThreshold){
      shortage = CouponThreshold - CartAmount;
      console.log('次回使えるクーポン発行まで後' + shortage.toLocaleString() + '円')
    }else{
      console.log('次回使えるクーポンあげる!');
    }
  }


  // ドロワー開閉
  const openDrawer = () => {
    drawer.classList.add('open');
    overlay.classList.add('visible');
    document.body.classList.add('no-scroll');
  };
  const closeDrawer = () => {
    drawer.classList.remove('open');
    overlay.classList.remove('visible');
    document.body.classList.remove('no-scroll');
  };

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  // カート内容取得＆ドロワー開く
  async function refreshCart() {
    const cart = await (await fetch('/cart.js')).json();
    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img src="${item.image}" alt="${item.product_title}" class="cart-item__image">
        <div class="cart-item__info">
          <a href="${item.url}" class="cart-item__title">${item.product_title}</a>

          <div class="cart-item__qty">
            <button class="data-q_change" data-key="${item.key}" data-q_change="-1">−</button>
            <input style="width:30px;" readonly type="number" value="${item.quantity}" min="1" data-key="${item.key}" class="qty-input"> 
            <button class="data-q_change" data-key="${item.key}" data-q_change="1">＋</button>
          </div>

          <div class="cart-item__price">¥${(item.original_line_price/100).toLocaleString()}</div>
          <button class="remove-from-cart-btn" data-key="${item.key}">削除</button>
        </div>
      </div>
    `).join('') || '<p>カートは空です。</p>';
    totalEl.textContent = '合計: ¥' + (cart.total_price/100).toLocaleString();
    openDrawer();
  }

  // 削除ボタン
  $(document).on('click', '.remove-from-cart-btn', function(event) {
    const itemKey = event.target.dataset.key;
    if (itemKey) {
      removeItemFromCart(itemKey, event.target);
    }
  });

  // 数量調整ボタン
  $(document).on('click', '.data-q_change', function(event) {
    console.log('数量調整ボタンクリック');
    const itemKey = event.target.dataset.key;
    const change = parseInt(event.target.dataset.q_change);
    const quantityInput = $(`input.qty-input[data-key="${itemKey}"]`)[0]; 
    console.log('quantityInput'+quantityInput);
    console.log(';;;'+$(`input.qty-input[data-key="${itemKey}"]`));
    console.log('itemKey:'+itemKey);
    if (quantityInput) {
      let currentQuantity = parseInt(quantityInput.value);
      let newQuantity = currentQuantity + change;
      if (newQuantity >= 1) {
        quantityInput.value = newQuantity;
        changeCartQuantity(itemKey, newQuantity);
      }
    }
  });
  

  // Cart API を使用して、カートから商品を削除する関数
  async function removeItemFromCart(itemKey, clickedButton) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
        }),
      });
      if (!response.ok) {
        throw new Error('カートからアイテムを削除できませんでした。');
      }

      const updatedCart = await response.json();
      console.log('アイテムを削除しました。カートを更新しました:', updatedCart);
      
      console.log('カートの合計'+(updatedCart.total_price/100).toLocaleString());
      totalEl.textContent = '合計: ¥' + (updatedCart.total_price/100).toLocaleString();

      // 💡 削除後の表示を最新の状態にするため、refreshCart()を呼び出す
      refreshCart();
      CartAmountRecalculation();
    } catch (error) {
      console.error('アイテムの削除中にエラーが発生しました:', error);
    }
  }

  // Cart API を使用して、カートから商品を調整する関数
  async function changeCartQuantity(itemKey, newQuantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newQuantity,
        }),
      });

      if (!response.ok) {
        alert('在庫数により数量変更が反映されないことがあります。決済画面で最終数量をご確認ください。');
        throw new Error('アイテムの数量を変更できませんでした。');
        console.log('アイテムの数量を変更できません:', updatedCart);
      }

      const updatedCart = await response.json();
      console.log('数量が変更されました。カートを更新しました:', updatedCart);

      // 💡 この部分を修正
      await new Promise(r => setTimeout(r, 100)); // サーバー側の更新を待つ
      refreshCart(); // カート全体を再描画する
      CartAmountRecalculation();
    } catch (error) {
      console.error('数量変更エラー:', error);
    }
  }

  // 「バッグに追加」ボタン全て
  addBtns.forEach(btn => {
    btn.addEventListener('click', async e => {
      e.preventDefault();
      const id = btn.dataset.variantId;
      if (!id) return;
      await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id,quantity:1})
      });
      await new Promise(r => setTimeout(r, 100));
      refreshCart();
      CartAmountRecalculation();
    });
  });

  // ヘッダーのカートボタン
  if (cartBtn) {
    cartBtn.addEventListener('click', e => {
      e.preventDefault();
      refreshCart();
      CartAmountRecalculation();
    });
  }
});